import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(async () => {
  window.location.href = 'https://saponet.mynavi.jp/pickup/yelloop'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})